import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from '@nextui-org/react';
import React from 'react';
import { INotfis } from '../../../../interfaces/response/Notfis/INotfisResponse';
import useOrderListTable, { Header } from './hooks/useOrderListTable';

export interface IOrderListTable {
  orders: INotfis[];
}

const OrderListTable: React.FC<IOrderListTable> = ({ orders }): JSX.Element => {
  const { cellData, columns, setSortDescriptor, sortDescriptor, sortedOrders } =
    useOrderListTable({
      orders,
    });

  return (
    <Table
      aria-label="Tabela da rota selecionada"
      isHeaderSticky
      selectionMode="single"
      classNames={{
        wrapper: ['xl:max-h-[60vh]', 'max-h-[50vh]'],
      }}
      sortDescriptor={sortDescriptor}
      onSortChange={setSortDescriptor}
    >
      <TableHeader columns={columns}>
        {({ key, name }) => (
          <TableColumn key={key} allowsSorting>
            {name}
          </TableColumn>
        )}
      </TableHeader>

      <TableBody items={sortedOrders} emptyContent="Nenhuma Notfis no momento">
        {(item) => (
          <TableRow key={item.idIntegracaoNotfis}>
            {(columnKey) => (
              <TableCell>
                <p className="text-foreground-600">
                  {cellData(item, columnKey as Header)}
                </p>
              </TableCell>
            )}
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default OrderListTable;
